import React from 'react';
import {useTranslation} from "react-i18next";
const DataOverview = ({data}) => {
    const { t } = useTranslation();
    return (
        <div className="step">
            <h4>{t("Finalize and Upload Offices")}</h4>
            <h4>{t("CSV Field Details")}</h4>
            {data.data && data.headers && (
                <>
                    <div className="overflow-x-auto data-table small-data-table mb-4">
                        <table>
                            <thead>
                            <tr>
                                {data.headers.map((key) => (
                                    <th key={key}>{key}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {data.data.map((item, index) => (
                                <tr key={index}>
                                    {data.headers.map((header, headerIndex) => (
                                        <td key={headerIndex}>{item[header]}</td>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
};

export default DataOverview;
